import { Observable, of } from 'rxjs';

import { ArticleData } from '@/data/article.data';
import { ArticleDataModel } from '@/components/Article/article.model';
import { HomeArticleData } from '@/data/home-articles.data';
import { HomeArticle } from '@/views/Home/home-article.model';

export const getArticles = (): Observable<ArticleDataModel> => of(ArticleData);

export const getHomeArticles = (): Observable<HomeArticle[]> => of(HomeArticleData);
